var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("d-inline-block btn rounded px-1 py-0 btn-sm btn-" + _vm.color),on:{"click":_vm.btnClick}},[(_vm.icon)?_c('i',{class:("icon-" + _vm.icon)}):_vm._e(),_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }